import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Opleidingen overzicht
 * Slug: opleidingen_overview
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.opleidingen_overview-layout');

	layouts.forEach((layout) => {
		const cols = gsap.utils.toArray(".opleiding-col");

		gsap.from(cols, {
			y: -20,
			opacity: 0,
			stagger: 0.2,
			scrollTrigger: {
				trigger: cols[0]
			}
		})
	});
});
